"use strict";
exports.__esModule = true;
exports.toText = void 0;
var prismic_richtext_1 = require("prismic-richtext");
var toText = function (prismicText) {
    if (!prismicText) {
        return undefined;
    }
    var text = prismicText instanceof Array ? prismic_richtext_1.asText(prismicText) : prismicText;
    return text.trim().replace(/\r?\n|\r/g, '');
};
exports.toText = toText;
//# sourceMappingURL=text.js.map